<app-page [pageTitle]="'CUSTOMERS.PREVIEW_PAGE.TITLE'">
  <div class="template-page">
    <div class="template-cards">
      <app-select-template
        (selectedTemplate)="onTemplateSelect($event)"
        [disableEmailTemplates]="hasNoCustomerWithEmail"
        [disableSmsTemplates]="hasNoCustomerWithSms"
      ></app-select-template>
      <app-preview-template
        (canTemplateRender)="canTemplateRender($event)"
        [selectedTemplate]="selectedTemplate"
      ></app-preview-template>
    </div>
    <div class="alerts-and-actions">
      @if ((reachedExpressEmailLimit$ | async) === false || (reachedExpressEmailLimit$ | async) === null) {
        @if (nbCustomersMissing || nonPaidBulkSms) {
          <glxy-alert
            class="center-icon-alert"
            type="warning"
            >
            <div class="alert-content-wrapper">
              @if (nbCustomersMissing && !nonPaidBulkSms) {
                {{ customerMissingFieldText | async }}
              }
              @if (nonPaidBulkSms) {
                {{ 'CUSTOMERS.PREVIEW_EMAIL.NO_BULK_FOR_GF_ERROR' | translate : { appName: appName$ | async } }}
              }
              <ng-container *ngTemplateOutlet="actionButtons"></ng-container>
            </div>
          </glxy-alert>
        } @else {
          <ng-container *ngTemplateOutlet="actionButtons"></ng-container>
        }
      }

      @if (reachedExpressEmailLimit$ | async) {
        <glxy-alert class="center-icon-alert" type="error">
          <div class="alert-content-wrapper">
            {{ 'CUSTOMERS.PREVIEW_EMAIL.NO_EMAIL_FOR_EXPRESS_ERROR' | translate }}
            <div class="action-buttons">
              <button (click)="openUpgradeDialog()" mat-stroked-button>
                {{ 'CUSTOMERS.PREVIEW_EMAIL.UPGRADE' | translate }}
              </button>
              <button (click)="cancel()" mat-stroked-button>
                {{ 'COMMON.ACTION_LABELS.CANCEL' | translate }}
              </button>
            </div>
          </div>
        </glxy-alert>
      }
    </div>
  </div>
</app-page>

<ng-template #actionButtons>
  <div class="action-buttons">
    <button (click)="cancel()" mat-stroked-button>
      {{ 'COMMON.ACTION_LABELS.CANCEL' | translate }}
    </button>
    <app-processing-button
      (buttonClick)="send()"
      [buttonText]="customersSelectedText | async"
      [dataAction]="'send-to-x-customers-button'"
      [disabled]="isButtonDisabled"
      [isProcessing]="sendingInProgress"
      data-action="send-to-x-customers-button"
      [raised]="true"
    ></app-processing-button>
  </div>
</ng-template>
